export default {
      id: "activity-details-usage",
      viewBox: "0 0 32 24",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#activity-details",
      toString: function () {
        return this.url;
      }
    }